import React, { useEffect, useRef } from "react";
import { StaticImage } from "gatsby-plugin-image";

import { Typography, Button } from "@novaescola/eva-react-v2";

import { useInView } from "../../hooks/useInView";

const SchoolManagement = () => {
  const schoolManagementRef = useRef(null);

  const isInView = useInView(schoolManagementRef);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const previewEventSent = window.dataLayer.filter(
      (el) =>
        el.label &&
        el.label ===
          "JORNALISMO: bloco temático - gestão escolar - bloco visualizado"
    );

    if (isInView && previewEventSent.length === 0) {
      window.dataLayer.push({
        event: "block_visualization",
        label:
          "JORNALISMO: bloco temático - gestão escolar - bloco visualizado",
      });
    }
  }, [isInView]);

  return (
    <div className="theme-block eva-card eva-bg-inst-50 eva-mb-06">
      <div className="eva-card-info">
        <Typography variant="title" size={6} className="eva-mb-04" asChild>
          <p ref={schoolManagementRef}>
            <i className="fa-regular fa-star eva-mr-03 eva-body-2"></i>
            Invista na sua carreira!
          </p>
        </Typography>
        <StaticImage
          src="https://thumbor.novaescola.org.br/bcdoBL6zmsPMzppllTQuQ468EPM=/nova-escola-producao.s3.amazonaws.com/yGM6XJZxtqjPKDGUD2ukHd33NEZF2CrmpZ9xZ4hmX8UpmUb2fpBvdZ5cYwbw/conselho-de-classe.jpg"
          alt=""
          width={328}
          height={184}
          className="eva-mb-06"
        />
        <Typography variant="body" size={2} className="eva-mb-06">
          Faça o curso Coordenador Pedagógico: do planejamento à formação
        </Typography>
        <Button variant="outline-primary" size="medium" asChild>
          <a
            type="button"
            className="eva-btn-full eva-mt-02"
            href="https://cursos.novaescola.org.br/curso/11324/coordenador-pedagogico-do-planejamento-a-formacao/resumo"
            data-track="JORNALISMO: bloco temático - gestão escolar - clique no botão"
          >
            COMEÇAR AGORA
          </a>
        </Button>
      </div>
    </div>
  );
};

export default SchoolManagement;
